var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230 1200 c0 -27 3 -30 30 -30 27 0 30 3 30 30 0 27 -3 30 -30 30 -27 0 -30 -3 -30 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 1208 c3 -20 8 -21 76 -19 l72 2 0 -210 0 -211 30 0 30 0 0 210 0 210 75 0 c68 0 75 2 75 20 0 19 -7 20 -181 20 -179 0 -180 0 -177 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 1150 c0 -38 -2 -40 -30 -40 -23 0 -30 -4 -30 -20 0 -16 7 -20 30 -20 l30 0 0 -130 c0 -117 2 -132 20 -150 13 -13 33 -20 60 -20 33 0 40 3 40 20 0 13 -7 20 -19 20 -42 0 -51 24 -51 146 l0 114 35 0 c28 0 35 4 35 20 0 16 -7 20 -35 20 -34 0 -35 1 -35 40 0 36 -2 40 -25 40 -22 0 -25 -4 -25 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830 1109 c-14 -5 -33 -20 -42 -32 l-18 -22 0 28 c0 22 -4 27 -25 27 l-25 0 0 -170 0 -170 25 0 25 0 0 125 c0 112 2 127 20 145 11 11 33 20 49 20 21 0 30 6 34 22 10 37 0 44 -43 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019 1110 c-77 -22 -113 -74 -113 -164 1 -115 54 -176 153 -176 49 0 111 21 111 38 -1 26 -17 32 -46 17 -34 -17 -87 -20 -116 -4 -11 6 -26 26 -34 44 -27 64 -26 65 96 65 l110 0 0 40 c0 101 -73 165 -161 140z m84 -58 c9 -10 20 -33 23 -50 l7 -32 -80 0 c-44 0 -82 3 -86 6 -8 8 10 55 30 76 22 24 85 24 106 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386 1109 c-16 -4 -39 -18 -52 -30 l-24 -22 0 26 c0 22 -5 27 -25 27 l-25 0 0 -170 0 -170 25 0 25 0 0 125 c0 121 1 127 25 151 21 21 33 25 75 23 27 -2 48 -5 45 -7 -3 -3 1 -12 7 -20 8 -9 14 -63 16 -143 4 -128 5 -129 28 -129 24 0 24 0 24 123 0 126 -6 171 -21 161 -5 -3 -6 1 -3 9 11 30 -67 60 -120 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 930 l0 -160 30 0 30 0 0 160 0 160 -30 0 -30 0 0 -160z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItrent);
export default __webpack_public_path__ + "static/media/itrent.c5cfd0b53b80ec866086ad63b20860a8.svg";
export { ForwardRef as ReactComponent };